import React, { useEffect, useRef } from 'react';

const InputArea = ({ visitorName, input, setInput, onSubmit, onClearChat, isTyping }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, [isTyping, visitorName]);

    return (
        <div className="border-t border-white/10 p-4 bg-cyber-gray/10 backdrop-blur-sm">
            <div className="flex flex-col sm:flex-row sm:items-center text-primary/80 font-mono">
                <div className="flex items-center justify-between whitespace-nowrap mb-2 sm:mb-0">
                    <div className="flex items-center">
                        <span className="text-primary">{visitorName}@fccview</span>
                        <span className="text-primary/60">:~$ </span>
                    </div>
                    <button
                        onClick={onClearChat}
                        className="sm:hidden text-primary/60 text-xs font-mono hover:text-primary/80 px-2 py-1 rounded border border-white/10 hover:border-white/20 ml-4"
                    >
                        Clear Chat
                    </button>
                </div>
                <form onSubmit={onSubmit} className="flex-1">
                    <input
                        ref={inputRef}
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        className="w-full bg-transparent border-none outline-none sm:ml-2 font-mono text-primary/90 caret-primary placeholder-primary/30"
                        placeholder="Type your question or command..."
                        disabled={isTyping}
                    />
                </form>
            </div>
        </div>
    );
};

export default InputArea; 